import { defineComponent } from '@nuxtjs/composition-api';

const __default__ = defineComponent({ head: {} });

import { computed, ref } from 'vue';
import { useContext, useFetch } from '@nuxtjs/composition-api';
import { usePage, useBreadcrumbs, usePagePreloader } from '~/composables';


export default /*#__PURE__*/Object.assign(__default__, {
  __name: '_slug',
  setup(__props) {

const useSlugPage = () => {
  const { page, fetchPage } = usePage();
  const { route, i18n } = useContext();
  const pagePreloader = usePagePreloader();
  const { breadcrumbs, addCrumbs } = useBreadcrumbs();

  const pageSidebar = ref(null);
  const pageBlocks = ref([]);

  const splitContentToSidebarAndBlocks = () => {
    const clonePageBlocks = [...page.value.blocks];
    const sidebarIndex = clonePageBlocks.findIndex(
      (b) => b.type === 'json' && b.content.type === 'app-left-sidebar',
    );

    pageSidebar.value = clonePageBlocks
      .splice(sidebarIndex, 1)
      .pop().content.data;

    pageBlocks.value = [...clonePageBlocks];
  };

  useFetch(async () => {
    pagePreloader.start();

    await fetchPage(route.value.params.slug, {
      lang: i18n.locale,
    });

    const isContainSidebar = page?.value?.blocks.find(
      (b) => b.type === 'json' && b.content.type === 'app-left-sidebar',
    );

    if (isContainSidebar) {
      splitContentToSidebarAndBlocks();
    }

    addCrumbs(page?.value?.title);
    pagePreloader.stop();
  });

  const isOnlyTextareaBlocks = computed(() =>
    page?.value?.blocks?.every((block) => block.type === 'textarea'),
  );

  return {
    page,
    pageBlocks,
    pageSidebar,
    breadcrumbs,
    isOnlyTextareaBlocks,
  };
};

const { page, pageBlocks, pageSidebar, breadcrumbs, isOnlyTextareaBlocks } =
  useSlugPage();

return { __sfc: true,useSlugPage, page, pageBlocks, pageSidebar, breadcrumbs, isOnlyTextareaBlocks }
}

})